var __jsx = React.createElement;
import React from "react";
var SimpleInfoCard = function SimpleInfoCard(_ref) {
  var icon = _ref.icon,
    title = _ref.title,
    description = _ref.description,
    _ref$minHeight = _ref.minHeight,
    minHeight = _ref$minHeight === void 0 ? "min-h-20" : _ref$minHeight,
    id = _ref.id;
  return /*#__PURE__*/React.createElement("div", {
    id: id || "simple-info-card",
    className: "border-[1px] border-solid border-[#D6DFE9] rounded-[12px] p-2 ".concat(minHeight)
  }, /*#__PURE__*/React.createElement("div", {
    id: "".concat(id || "simple-info-card", "-content"),
    className: "flex items-center justify-between"
  }, /*#__PURE__*/React.createElement("div", {
    id: "".concat(id || "simple-info-card", "-icon-container"),
    className: "w-10 h-10  flex items-center justify-center flex-shrink-0"
  }, /*#__PURE__*/React.createElement("img", {
    id: "".concat(id || "simple-info-card", "-icon"),
    src: icon,
    alt: title,
    className: "w-12 h-12 object-contain"
  })), /*#__PURE__*/React.createElement("div", {
    id: "".concat(id || "simple-info-card", "-details"),
    className: "flex-1 mx-4"
  }, /*#__PURE__*/React.createElement("h3", {
    id: "".concat(id || "simple-info-card", "-title"),
    className: "text-[14px] md:text-xl font-bold text-gray-900 pt-1 pb-2"
  }, title), /*#__PURE__*/React.createElement("p", {
    id: "".concat(id || "simple-info-card", "-description"),
    className: "text-[#909090] text-[12px] md:text-[16px] leading-4"
  }, description))));
};
export default SimpleInfoCard;